import { Search } from '@/DTOS/InfoDevice/Search';
import request from '../../utils/request';

const InfoDeviceService = {
  search: (search: Search) => {
    return request('/infoDevice/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      deviceTypeId: any;
      model: any;
      pieces: any;
    }
  ) => {
    return request('/infoDevice/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          deviceTypeId: formData.deviceTypeId,
          model: formData.model,
          pieces: formData.pieces,
        },
      }),
    });
  },
};

export default InfoDeviceService;
